import { useFilterState } from './FilterStateContext';

/*
 * Drop-in replacements for react-redux's useSelector/useDispatch used by the
 * copied searchFilterNew panel components. They resolve against the modal's
 * private FilterStateContext store instead of the global redux store, so the
 * copies only need their `react-redux` import line swapped to this module.
 */

export const useSelector = selector => selector(useFilterState().rootState);

export const useDispatch = () => useFilterState().dispatch;
